// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  appVersion:"2.1.4",
  firebaseConfig: {
    apiKey: "AIzaSyBDzDAEcQtQWcZwwUfFfs7eLW3vtYQChGs",
    authDomain: "oso2-better-health.firebaseapp.com",
    databaseURL: "https://oso2-better-health.firebaseio.com",
    projectId: "oso2-better-health",
    storageBucket: "oso2-better-health.appspot.com",
    messagingSenderId: "1086311211147",
    appId: "1:1086311211147:web:84562e8b8dd836b18df48e",
    measurementId: "G-D1LEN8XMV7",
  },
  defaultLanguage: "vn",
  //baseUrl: 'http://localhost:8088'
  //baseUrl: 'http://192.168.1.168:8088'
  baseUrl: 'https://bh.oso2.vn'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
